import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from "@angular/core";
import { FormArray, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { DigitalSignatureService } from "src/app/core/services/digital-signature.service";
import { UtilsService } from "src/app/core/services/utils.service";

@Component({
  selector: 'app-work-job-contract',
  templateUrl: './work-job-contract.component.html',
  styleUrls: ['./work-job-contract.component.scss']
})
export class WorkJobContractComponent implements OnInit, OnChanges {
  form: FormGroup;

  documentList = [];

  @Input() workJobContracts;
  @Input() isExhibition = false;
  @Input() contractRemovedId;
  @Input() isConsult = false;

  @Output() SaveContract = new EventEmitter();
  @Output() DeleteContract = new EventEmitter();

  constructor(private fb: FormBuilder, private utilsService: UtilsService, private digitalSignatureServ: DigitalSignatureService,) { }

  ngOnInit() {
    //this.buidlForm();
    console.log('init');
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.loadData(changes);
    this.removeData(changes);
  }



  loadData(changes: SimpleChanges) {
    const data = changes.workJobContracts?.currentValue as Array<any> | null;
    if (!data) return;


    if (this.contracts) {
      // 1) zera para índices baterem
      this.contracts.clear();
      this.documentList = [];

      // 2) remonta os itens
      data.forEach((w, i) => {
        const fg = this.addWorkJobContract(); // retorna o FormGroup recém-adicionado

        fg.patchValue({
          id: w.id ?? null,
          title: w.title ?? '',
          documentId: w.digitalSignatureDocumentId,
          creationDate: this.toDisplayDate(w.creationDate) // <- normalizado p/ input date
        });



        this.getDocument(i, { documentId: w.digitalSignatureDocumentId, base64: w.document, extension: w.documentExtension });
        //this.documentList[i] = { doc: w.document, docExtension: w.documentExtension, url: w.document };

        // Se o backend retorna URL (não base64), não monte 'data:...;base64,...'
        /* const isUrl = typeof w.document === 'string' && /^https?:\/\//i.test(w.document);
     
         if (!isUrl && w.document) {
           // documento em base64 (antigo comportamento)
           this.getDocument(i, { base64: w.document, extension: w.documentExtension });
         } else {
           // guarde URL/extension para download/preview apropriado
           this.documentList[i] = { doc: null, docExtension: w.documentExtension, url: w.document };
         }*/
      });
    }

  }


  /** Formata Date -> dd/MM/yyyy */
  private formatDisplayDate(d: Date): string {
    const dd = String(d.getDate()).padStart(2, '0');
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const yyyy = d.getFullYear();
    return `${dd}/${mm}/${yyyy}`;
  }

  /** Retorna hoje em dd/MM/yyyy */
  private todayDisplay(): string {
    return this.formatDisplayDate(new Date());
  }

  /** Converte várias entradas (yyyy-mm-dd, yyyy-mm-dd hh:mm, Date, dd/MM/yyyy) para dd/MM/yyyy */
  private toDisplayDate(value: unknown): string {
    if (!value) return this.todayDisplay(); // fallback amigável
    if (value instanceof Date) return this.formatDisplayDate(value);

    const s = String(value).trim();

    // yyyy-mm-dd [hh:mm...]
    const m1 = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (m1) return `${m1[3]}/${m1[2]}/${m1[1]}`;

    // dd/mm/yyyy já formatado
    const m2 = s.match(/^(\d{2})\/(\d{2})\/(\d{4})/);
    if (m2) return m2[0];

    // tenta parsear genericamente
    const d = new Date(s);
    return isNaN(d.getTime()) ? this.todayDisplay() : this.formatDisplayDate(d);
  }


  // Ajuda: extrai só YYYY-MM-DD de várias formas de data.
  private toDateInput(value: unknown): string | null {
    if (!value) return null;
    const s = String(value).trim();
    // bate se já vier "2025-08-25" ou "2025-08-25 12:49" ou ISO
    const m = s.match(/^(\d{4}-\d{2}-\d{2})/);
    return m ? m[1] : null;
  }


  getWorkJobContractForm(index: number) {
    const formGroup = this.contracts.controls[index] as FormGroup;
    return formGroup.controls;
  }

  removeData(changes: SimpleChanges) {
    const id = changes.contractRemovedId?.currentValue;
    if (id) {
      const array = this.contracts.controls;
      const i = array.findIndex((el: any) => el.id === id);
      this.contracts.removeAt(i);
      this.documentList.splice(i, 1);
    }
  }

  /** Getter seguro: sempre retorna um FormArray válido */
  get contracts(): FormArray {
    // se o form não existir por algum motivo, recria
    if (!this.form) this.form = this.createForm();

    let ctrl = this.form.get('contracts');
    if (!(ctrl instanceof FormArray)) {
      ctrl = this.fb.array([]);
      this.form.addControl('contracts', ctrl);
    }
    return ctrl as FormArray;
  }

  private createForm(): FormGroup {
    return this.fb.group({
      contracts: this.fb.array([]),
    });
  }

  buidlForm() {
    this.form = this.fb.group({
      contracts: this.fb.array([]),
    });
  }


  /*addWorkJobContract(value?) {
    const contract = this.fb.group({
      id: [null],
      title: [
        { value: "", disabled: this.isExhibition },
        Validators.required,
      ],
      creationDate: [
        {  value: this.getTodayDate(), disabled: this.isExhibition },
        Validators.required,
      ],
    });

    if (value) {
      contract.patchValue(value);
      // workJobContract.patchValue({
      //   creationDate: value.creationDate.split(" ")[0],
      // });
    }

    this.contracts.push(contract);
     this.documentList.push({});
  }*/


  addWorkJobContract(initial?: Partial<any>) {
    const fg = this.fb.group({
      id: [initial?.id ?? null],
      title: [initial?.title ?? '', Validators.required],
      documentId: [],
      creationDate: [{
        value: initial?.creationDate ? this.toDisplayDate(initial.creationDate)
          : this.todayDisplay(),
        disabled: true
      }],
      document: [initial?.doc],
      documentExtension: [initial?.documentExtension ?? null]
    });

    this.contracts.push(fg);
    return fg;
  }

  removeWorkJobContract(i: number) {
    const id = this.contracts.controls[i].value.id;
    if (id) {
      this.DeleteContract.emit(id);
    } else {
      this.contracts.removeAt(i);
    }
  }

  private getTodayDate(): string {
    const today = new Date();
    return today.toISOString().split('T')[0]; // '2025-08-04'
  }

  private toApiCreationDate(value: unknown): string {
    if (!value) return new Date().toISOString().split("T")[0];
    const s = String(value).trim();
    const ddmmyyyy = s.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
    if (ddmmyyyy) {
      return `${ddmmyyyy[3]}-${ddmmyyyy[2]}-${ddmmyyyy[1]}`;
    }
    const isoDate = s.match(/^(\d{4}-\d{2}-\d{2})/);
    if (isoDate) return isoDate[1];
    const d = new Date(s);
    return isNaN(d.getTime())
      ? new Date().toISOString().split("T")[0]
      : d.toISOString().split("T")[0];
  }

  saveForm(i: number) {
    const contractForm = this.contracts.controls[i] as FormGroup;
    // creationDate está disabled — não entra em .value; usar getRawValue()
    const raw = contractForm.getRawValue();
    const doc = this.documentList[i]?.doc?.replace("", "");
    const docExtension = this.documentList[i]?.docExtension?.replace("", "");

    const payload = {
      id: raw.id,
      title: raw.title,
      creationDate: this.toApiCreationDate(raw.creationDate),
      documentFile: doc,
      documentFileExtension: docExtension,
    };

    if (contractForm.invalid) {
      this.contracts.controls.forEach((fg: FormGroup) =>
        Object.keys(fg.controls).forEach((key) => {
          fg.controls[key].markAsDirty();
        }),
      );
      return;
    }

    this.SaveContract.emit(payload);
  }


  downloadSignedDocument(index: number) {

    const item = this.documentList?.[index];
    const documentId = item?.documentId;

    if (!documentId) {
      //console.error('Documento não encontrado na lista.');
      return;
    }

    this.digitalSignatureServ.getSignedDocumentUrl(documentId).subscribe({
      next: (url: string) => {
        // Cria um link temporário para download
        const link = document.createElement('a');
        link.href = url;
        link.target = '_blank';
        link.download = '';
        link.click();
      },
      error: (err) => {
        //this.toast.show('Erro!', 'Não foi possível baixar o documento assinado.');
        console.error('Erro ao obter URL de download:', err);
      }
    });
  }

  downloadFile(index: number) {
    const doc = this.documentList[index]?.doc?.replace("", "");
    //const docExtension = this.documentList[index]?.docExtension?.replace("", "");

    // if (doc) this.utilsService.downloadFile(doc, `CONTRATO_${index}.${docExtension}`);

    const link = document.createElement('a');
    link.href = doc;
    link.target = '_blank';
    link.download = '';
    link.click();

  }

  getDocument(i, payload) {
    if (!payload) {
      this.documentList?.splice(i, 1);
      return;
    }

    const document = {
      id: i,
      documentId: payload.documentId,
      doc: payload.base64,
      docExtension: payload.extension
    };

    this.documentList.splice(i, 1);
    this.documentList.splice(i, 0, document);
    // this.documentList.push(document);
  }

  removeContractById(array, id) {
    const indice = array.findIndex((elemento) => elemento.id === id);
    if (indice !== -1) {
      array.splice(indice, 1);
    }
  }
}
